import { Banner, Box, Text } from '@betterment/samba-react';

export const DeferralRateNotEditable: React.FC<{ reason: string | null }> = ({ reason }) => (
  <Banner variant="critical">
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
      <Text>{reason ?? 'You cannot change your contribution rate at this time.'}</Text>
      <Text>Please contact your plan sponsor with any questions.</Text>
    </Box>
  </Banner>
);
